export default "__VITE_ASSET__B$3qrkKt__"